// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.featured_article_title_container {
  background-color: var(--background-theme-color);
  width: 100%;
  display: flex;
  justify-content: center;
}
.featured_article_title {
  color: #ffffff;
  padding: 2% 0 3% 0;
  font-weight: 700;
  font-family: kufam;
}
.featured_article_image_component {
  height: 100%;
  cursor: pointer;
}

.featured_article_image {
  width: 100% !important;
  object-fit: cover;
  border-radius: 10px;
}

.featured_article_thumbnail_overlay_content {
  position: absolute !important;
  bottom: 20px;
  background-color: rgba(20, 15, 45, 0.9) !important;
  color: #fff;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 2%;
}
.featured_article_thumbnail_overlay_title {
  height: 55%;
  display: flex;
  align-items: center;
}

.featured_article_image_component_title {
  color: #ffffff;
  font-weight: 600;
}
.featured_article_view_count {
  color: var(--view-icon-color-white);
}
.featured_article_thumbnail_overlay_view_count {
  display: flex;
  align-items: center;
  gap: 10px;
}
.featured_article_thumbnail_overlay_name_and_date {
  color: #ffffff;
}
.featured_article_details_wrapper {
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.featured_article_button {
  background-color: var(--background-theme-color) !important;
  color: #ffffff !important;
  border-radius: 10px;
  border: 1px solid white !important;
  background: transparent !important;
}

.featured_article_content {
  width: 40%;
  display: flex;
  flex-direction: column;
}
.featured_article_content_title_wrapper {
  display: flex;
  height: 40%;
  flex-direction: column;
  gap: 6%;
}
.featured_article_content_sub_title_wrapper {
  display: flex;
  flex-direction: column;
  height: 60%;
  justify-content: space-evenly;
}
.featured_story_article {
  color: var(--tag-color);
  font-weight: 700;
  font-family: kufam;
}
.featured_story_article_title {
  color: #ffffff;
  font-weight: 500;
  font-family: kufam;
  cursor: pointer;
}
.featured_article_sub_title {
  font-weight: 450;
  cursor: pointer;
}
.featured_article_continue_reading_wrapper {
  display: flex;
  align-items: center;
}
.featured_article_mobile_view_title {
  color: var(--background-theme-color);
  font-family: kufam;
}
.featured_article_mobile_view_sub_title {
  font-family: kufam;
}
.featured_article_content_mobile_view {
  width: 95%;
  display: flex;
  flex-direction: column;
  padding: 5% 0 5% 0;
}
.featured_article_container_mobile_view {
  position: relative;
  z-index: 1;
  width: 95%;
}
.featured_article_back_ground_container_mobile_view {
  position: absolute;
  background-color: #140f2d;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 25%;
  z-index: 1;
}
.featured_story_article_container {
  display: flex !important;
  justify-content: center !important;
  position: relative;
  height: 100%;
}
.featured_article_back_ground_container {
  position: absolute;
  background-color: var(--background-theme-color);
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 37%;
  z-index: 1;
}

.recommended_story_desktop_container {
  display: grid;
  grid-template-columns: 65% 30%;
  height: 100%;
  width: 90%;
  justify-content: space-between;
}
.recommended_story_desktop_first_column_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 30px;
}
.recommended_story_desktop_title_container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 30px;
}
.recommended_story_desktop_title_container > h2 {
  font-weight: 600;
}
.recommended_story_desktop_second_column_container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: end;
}

.flex-column {
  flex-direction: column !important;
}
.w-auto {
  width: auto !important;
}
.recommended_story_desktop_main_container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 30px;
}
.recommended_story_mobile_main_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.recommended_story_mobile_middle_container {
  display: none;
  margin-top: 20px;
  width: 100%;
}

.recommended_story_mobile_first_container {
  margin-top: 20px;
}
.recommended_story_mobile_middle_container_loading {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.featured_story_continue_reading_text {
  color: #0d99ff;
  text-decoration: underline;
  font-weight: 600;
  cursor: pointer;
}
.featured_story_article_title_ta {
  color: #ffffff;
  font-weight: 550 !important;
  font-family: kufam;
  cursor: pointer;
}
.featured_article_sub_title_ta {
  font-weight: 450;
  cursor: pointer;

}
.featured_article_mobile_view_title_ta {
  font-family: kufam;
}
.featured_article_image_component_title_ta {
  color: #ffffff;
  font-weight: 550;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/user_article.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kDAAkD;EAClD,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,0DAA0D;EAC1D,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,OAAO;AACT;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;;AAEjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".featured_article_title_container {\n  background-color: var(--background-theme-color);\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.featured_article_title {\n  color: #ffffff;\n  padding: 2% 0 3% 0;\n  font-weight: 700;\n  font-family: kufam;\n}\n.featured_article_image_component {\n  height: 100%;\n  cursor: pointer;\n}\n\n.featured_article_image {\n  width: 100% !important;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.featured_article_thumbnail_overlay_content {\n  position: absolute !important;\n  bottom: 20px;\n  background-color: rgba(20, 15, 45, 0.9) !important;\n  color: #fff;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding: 2%;\n}\n.featured_article_thumbnail_overlay_title {\n  height: 55%;\n  display: flex;\n  align-items: center;\n}\n\n.featured_article_image_component_title {\n  color: #ffffff;\n  font-weight: 600;\n}\n.featured_article_view_count {\n  color: var(--view-icon-color-white);\n}\n.featured_article_thumbnail_overlay_view_count {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.featured_article_thumbnail_overlay_name_and_date {\n  color: #ffffff;\n}\n.featured_article_details_wrapper {\n  height: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.featured_article_button {\n  background-color: var(--background-theme-color) !important;\n  color: #ffffff !important;\n  border-radius: 10px;\n  border: 1px solid white !important;\n  background: transparent !important;\n}\n\n.featured_article_content {\n  width: 40%;\n  display: flex;\n  flex-direction: column;\n}\n.featured_article_content_title_wrapper {\n  display: flex;\n  height: 40%;\n  flex-direction: column;\n  gap: 6%;\n}\n.featured_article_content_sub_title_wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 60%;\n  justify-content: space-evenly;\n}\n.featured_story_article {\n  color: var(--tag-color);\n  font-weight: 700;\n  font-family: kufam;\n}\n.featured_story_article_title {\n  color: #ffffff;\n  font-weight: 500;\n  font-family: kufam;\n  cursor: pointer;\n}\n.featured_article_sub_title {\n  font-weight: 450;\n  cursor: pointer;\n}\n.featured_article_continue_reading_wrapper {\n  display: flex;\n  align-items: center;\n}\n.featured_article_mobile_view_title {\n  color: var(--background-theme-color);\n  font-family: kufam;\n}\n.featured_article_mobile_view_sub_title {\n  font-family: kufam;\n}\n.featured_article_content_mobile_view {\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  padding: 5% 0 5% 0;\n}\n.featured_article_container_mobile_view {\n  position: relative;\n  z-index: 1;\n  width: 95%;\n}\n.featured_article_back_ground_container_mobile_view {\n  position: absolute;\n  background-color: #140f2d;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: 25%;\n  z-index: 1;\n}\n.featured_story_article_container {\n  display: flex !important;\n  justify-content: center !important;\n  position: relative;\n  height: 100%;\n}\n.featured_article_back_ground_container {\n  position: absolute;\n  background-color: var(--background-theme-color);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: 37%;\n  z-index: 1;\n}\n\n.recommended_story_desktop_container {\n  display: grid;\n  grid-template-columns: 65% 30%;\n  height: 100%;\n  width: 90%;\n  justify-content: space-between;\n}\n.recommended_story_desktop_first_column_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 30px;\n}\n.recommended_story_desktop_title_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 30px;\n}\n.recommended_story_desktop_title_container > h2 {\n  font-weight: 600;\n}\n.recommended_story_desktop_second_column_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: end;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n.w-auto {\n  width: auto !important;\n}\n.recommended_story_desktop_main_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n.recommended_story_mobile_main_container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.recommended_story_mobile_middle_container {\n  display: none;\n  margin-top: 20px;\n  width: 100%;\n}\n\n.recommended_story_mobile_first_container {\n  margin-top: 20px;\n}\n.recommended_story_mobile_middle_container_loading {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.featured_story_continue_reading_text {\n  color: #0d99ff;\n  text-decoration: underline;\n  font-weight: 600;\n  cursor: pointer;\n}\n.featured_story_article_title_ta {\n  color: #ffffff;\n  font-weight: 550 !important;\n  font-family: kufam;\n  cursor: pointer;\n}\n.featured_article_sub_title_ta {\n  font-weight: 450;\n  cursor: pointer;\n\n}\n.featured_article_mobile_view_title_ta {\n  font-family: kufam;\n}\n.featured_article_image_component_title_ta {\n  color: #ffffff;\n  font-weight: 550;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
